import { get, isObject, isString } from 'lodash';
import { toast } from '@oliasoft-open-source/react-ui-library';
import {
  BAD_REQUEST,
  CONFLICT,
  FORBIDDEN,
  GONE,
  NOT_FOUND,
  SERVER_ERROR,
  UNAUTHORIZED_STATUS
} from '~common/constants';
import { NAVIGATION_CONSTANTS, NotificationTypes } from '../constants';
import { history } from '../reduxStore';

export default (status: number, data: any) => {
  if (status === UNAUTHORIZED_STATUS) {
    history.push(NAVIGATION_CONSTANTS.ROOT);

    return;
  }
  if (status === FORBIDDEN || status === NOT_FOUND || status === CONFLICT || status === GONE) {
    toast({
      message: {
        type: NotificationTypes.ERROR,
        heading: 'Error!',
        content: data.msg,
      }
    });
    return;
  }

  if (status === SERVER_ERROR || status === BAD_REQUEST) {
    // AuthDB error single
    if (typeof data === 'string') {
      toast({
        message: {
          type: NotificationTypes.ERROR,
          heading: 'Error!',
          content: data,
        }
      });
      return;
    }
    if (data.msg && isObject(data.msg) && !data.msg.errors) {
      const message = get(data.msg, 'original.detail', 'Something went wrong');
      toast({
        message: {
          type: NotificationTypes.ERROR,
          heading: 'Error!',
          content: message,
        }
      });
      return;
    }
    if (isString(data.msg)) {
      toast({
        message: {
          type: NotificationTypes.ERROR,
          heading: 'Error!',
          content: data.msg,
        }
      });
      return;
    }

    if (Array.isArray(data)) {
      // Handles all errors from validations
      for (let err of data) {
        toast({
          message: {
            type: NotificationTypes.ERROR,
            heading: 'Error!',
            content: err.messages,
          }
        });
      }
      return;
    }

    // Sequelize and  AuthZ errors
    if (data.msg.errors && Array.isArray(data.msg.errors)) {
      for (let err of data.msg.errors) {
        toast({
          message: {
            type: NotificationTypes.ERROR,
            heading: 'Error!',
            content: err.message,
          }
        });
      }
    }
  }
};
